import { render, staticRenderFns } from "./FQCReportDetail.vue?vue&type=template&id=3b37f405"
import script from "./FQCReportDetail.vue?vue&type=script&lang=js"
export * from "./FQCReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports